import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";

import { contents } from "./Contents";
import { closeCityDialog, closeContentPopup, closeDialog } from "../../store/actions";

const ContentPopup = (props) => {
  useEffect(() => {
    props.closeDialogDispatch();
    props.closeCityDialogDispatch();
    document.querySelector("#popup-content").scrollTo({ top: 0 });
  }, [props.name, props.label]);

  const showDialog = useSelector(state => state.ui.showDialog);
  const Content = contents[props.name];

  return (
    <div
      className={`popup-dialog opened`}
      style={{ top: `${window.innerWidth >= 992 ? "155" : "70"}px` }}
    >
      <a href="#" onClick={props.closeContentPopup} className="dialog-dismiss">×</a>
      <div
        className={`tabs-dialog-body content ${showDialog ? "block-scroll" : ""}`}
        id="popup-content"
      >
        <div className={`h1-row ${props.h1classes}`}>
          <div className="flex-filler news news-square" id="news-wrap"/>
          <h1 className="h1">
            {props.icon && <i className={`icon icon-${props.icon} icon-lg`}/>}
            {props.title}
            {props.icon && <i className={`icon icon-${props.icon} icon-lg icon-right`}/>}
          </h1>
          <div className="flex-filler"/>
        </div>

        <Content {...props}/>

      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  closeDialogDispatch: () => dispatch(closeDialog()),
  closeCityDialogDispatch: () => dispatch(closeCityDialog()),
  closeContentPopup: () => dispatch(closeContentPopup())
});

export default connect(null, mapDispatchToProps)(ContentPopup);
